<script setup lang="ts">
import type { NavigationMenuViewportProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { NavigationMenuViewport, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	NavigationMenuViewportProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<div
		class="perspective-[2000px] absolute left-0 top-full flex justify-center"
	>
		<ClientOnly>
			<NavigationMenuViewport
				v-bind="forwardedProps"
				:class="
					cn(
						'navigation-menu-viewport origin-top-center relative mt-0 h-(--reka-navigation-menu-viewport-height) w-(--reka-navigation-menu-viewport-width) overflow-hidden rounded-md border bg-primary text-popover-foreground shadow-lg transition-[width,height] duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90',
						props.class
					)
				"
			/>
		</ClientOnly>
	</div>
</template>
